'use client';

import { c as _c } from "react/compiler-runtime";
import SvgAdd from '@common/icon/SvgAdd';
import SvgMinus from '@common/icon/SvgMinus';
import SvgTrash from '@common/icon/SvgTrash';
import { cn } from '@core/utils';
export interface QuantityStepperProps {
  count: number;
  min?: number;
  max?: number;
  onCountChange?: (count: number) => void;
  onDelete?: () => void;
  disabled?: boolean;
  className?: string;
}
export const QuantityStepper = t0 => {
  const $ = _c(27);
  const {
    count,
    min: t1,
    max,
    onCountChange,
    onDelete,
    disabled: t2,
    className
  } = t0;
  const min = t1 === undefined ? 1 : t1;
  const disabled = t2 === undefined ? false : t2;
  const isMinReached = disabled || count <= min;
  const isMaxReached = disabled || max !== undefined && count >= max;
  const canDelete = !disabled && onDelete !== undefined;
  let t3;
  if ($[0] !== className) {
    t3 = cn("flex h-36 w-90 items-center justify-center overflow-hidden rounded-xsmall border border-Gray-400 bg-Gray-white mobile-tablet:h-26 mobile-tablet:w-auto", className);
    $[0] = className;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== canDelete || $[3] !== count || $[4] !== isMinReached || $[5] !== min || $[6] !== onCountChange || $[7] !== onDelete) {
    t4 = isMinReached ? <button type="button" onClick={onDelete} aria-label={"\uC0AD\uC81C"} disabled={!canDelete} className={cn("flex h-full items-center pl-12 pr-8 mobile-tablet:pl-8 mobile-tablet:pr-4", canDelete ? "text-Gray-600" : "text-Gray-400")}><SvgTrash className="size-12" /></button> : <button type="button" onClick={() => onCountChange?.(Math.max(min, count - 1))} aria-label={"\uC218\uB7C9 \uAC10\uC18C"} className="flex h-full items-center pl-12 pr-8 text-Gray-900 mobile-tablet:pl-8 mobile-tablet:pr-4"><SvgMinus className="size-12" /></button>;
    $[2] = canDelete;
    $[3] = count;
    $[4] = isMinReached;
    $[5] = min;
    $[6] = onCountChange;
    $[7] = onDelete;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== count) {
    t5 = <span className="min-w-20 text-center font-400 text-Gray-black typo-body4 mobile-tablet:typo-caption1">{count}</span>;
    $[9] = count;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== count || $[12] !== max || $[13] !== onCountChange) {
    t6 = () => onCountChange?.(Math.min(max ?? Infinity, count + 1));
    $[11] = count;
    $[12] = max;
    $[13] = onCountChange;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const t7 = isMaxReached ? "text-Gray-400" : "text-Gray-900";
  let t8;
  if ($[15] !== t7) {
    t8 = cn("flex h-full items-center pl-8 pr-12 mobile-tablet:pl-4 mobile-tablet:pr-8", t7);
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <SvgAdd className="size-12" />;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== isMaxReached || $[19] !== t6 || $[20] !== t8) {
    t10 = <button type="button" onClick={t6} aria-label={"\uC218\uB7C9 \uC99D\uAC00"} disabled={isMaxReached} className={t8}>{t9}</button>;
    $[18] = isMaxReached;
    $[19] = t6;
    $[20] = t8;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t3 || $[24] !== t4 || $[25] !== t5) {
    t11 = <div className={t3}>{t4}{t5}{t10}</div>;
    $[22] = t10;
    $[23] = t3;
    $[24] = t4;
    $[25] = t5;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
};